<template>
  <div>
    <!-- tab开始 -->
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane :label='"全部 "+ "(" + (pageConfig.total) + ")"' name="all"></el-tab-pane>
      <el-tab-pane :label='"待上架"+ "(" + (allKinds.bePutOnCount) + ")"' name="10"></el-tab-pane>
      <el-tab-pane :label='"已上架 "+ "(" + (allKinds.onTheShelfCount) + ")"' name="20"></el-tab-pane>
    </el-tabs>
    <!-- tab结束 -->

    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
      :buttonList="buttonList"
      @btnCallFunction="callFunction"
      @resetBtn="resetBtn"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
    
      <template v-slot:WarehouseId>
        <el-select
          multiple
          filterable
          v-model="filters.WarehouseId"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in warehouses"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:InventoryStatus>
        <el-select
          multiple
          filterable
          v-model="filters.InventoryStatus"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in statusList"
            :label="item.text"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:tdate>
        <el-select
          class="dateSelect"
          v-model="filters.DateType"
          placeholder="请选择"
          collapse-tags
        >
          <el-option
            v-for="item in createDateTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-date-picker
          v-model="filters.tdate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </template>

     

      <template slot-scope="scope" slot="resynchronize">
        <div>
          <el-button
            style="margin-left: 10px"
            :underline="false"
            type="text"
            size="small"
            @click.native="getbusinessLoglist(scope.row)"
          >
            查看日志
          </el-button>
          <br />
        </div>
      </template>
      <template v-slot:realName>
        <el-select multiple v-model="filters.realName" filterable placeholder="请选择" collapse-tags>
          <el-option
            v-for="item in userList"
            :label="item.realName"
            :value="item.realName"
            :key="item.realName"
          ></el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="operatorInfo">
          <span>收货:{{ scope.row.completeReceiptUser }}</span>
          <br />
          <span>上架:{{ scope.row.completePutOnUser }}</span>
      </template>
    </TwTable>

    

    <LogDialog
      :logPageConfig="logPageConfig"
      :showLog="showLog"
      :requestData="{
        businessType: 35,
        businessCode: currentRow.batchCode,
      }"
      :requestApi="'/WareHouse/BusinessLogServices'"
      :requestMethod="'get'"
      v-if="showLog"
      @showDialog="showDialog"
    ></LogDialog>

    <!-- 签收 -->
    <el-dialog
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="上架"
      width="30%"
      :before-close="onSubmicancel"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addRuleForm"
      >
     
           <el-row>
            <el-col>
                <el-form-item label="库位" prop="locationCode">
            <el-select
              v-model="addForm.locationCode"
              style="width: 100%"
              placeholder="请选择库位"
              multiple 
              clearable 
              filterable 
            >
              <el-option
                v-for="item in locationList"
                :label="item.locationCode"
                :value="item.locationCode"
                :key="item.locationCode"
              ></el-option>
            </el-select>
          </el-form-item>
            </el-col>
             </el-row>
     
          <el-row>
            <el-col :span="24">
              <el-form-item
                label="备注"
                prop="Remark"
         
              >
                <el-input
                  v-model="addForm.Remark"
                  auto-complete="off"
                  type="textarea"
                  autosize
                  maxlength="200"
                  show-word-limit
                  :autosize="{ minRows: 2, maxRows: 4}"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
          <el-button @click="onSubmicancel">取消</el-button>
          <el-button type="primary" @click="onAddSubmit" :loading="addLoading"
            >上架</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getPutOnStockTaskAsync,
  exportPutOnStockAsyncOut,
  getWarehouseLocationByWarehouseId,
  insertTFPutOnStock,
  
} from "@/api/transfer/tfPutOnStock/putOnStockManage.js";
import {getOperatorInfo,} from "@/api/api.js";
import { getButtonList } from "../../../promissionRouter";
import TwTable from "../../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../../components/TwTable/mixins";
import axios from "axios";
import { thereAre } from "util/util";
import LogDialog from "../../../components/TwTable/components/logDialog";
export default {
  components: { LogDialog, TwTable },
  mixins: [TwTable_mixins],
  data() {
    return {
      userList: [],
      activeName: "all",
      createDateTypeOptions: [
        {
          value: "tos.CreateTime",
          label: "创建时间",
        },
        {
          value: "tet.CompleteReceiptDate ",
          label: "完成收货",
        },
        {
          value: "tet.CompletePutOnDate ",
          label: "完成上架",
        },
      ],
      filters: {
        DateType: "tos.CreateTime",
      },
      tableConfig: {
        showResetButton:true,
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: true, // 显示操作栏
        operate: {
          //操作栏配置
          align: "center",
          width: "120",
          options: [
            {
              prop: "resynchronize",
              name: "日志",
              size: "small",
              type: "text",
              slot: true,
            },
            // {
            //   name: "日志",
            //   size: "small",
            //   type: "text",
            //   event: "getbusinessLoglist", // 操作的事件名
            // },
          ],
        },
        column: [
          // 表格列配置
         
          {
            prop: "batchCode",
            label: "上架单号",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
            {
            prop: "signForNumber",
            label: "收货单号",
            align: "center",
            sortable: true,
          
            minWidth: "150",
          },
          {
            prop: "deliveryOrdeNo",
            label: "WMS进仓号",
            align: "center",
            sortable: true,
          
            minWidth: "170",
          },
           {
            prop: "customName",
            label: "客户货主",
            align: "center",
            sortable: true,
            minWidth: "130",
          },
           {
            prop: "warehouseName",
            label: "仓库",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
           {
            prop: "storages",
            label: "库位",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "boxCount",
            label: "实收箱数",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
          {
            prop: "receivedBoxVolume",
            label: "实收体积",
          },
          {
            prop: "receivedBoxWeight",
            label: "实收重量",
          },
          {
            prop: "deliveryTypeText",
            label: "入库类型",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
          
          {
            prop: "inventoryStatusText",
            label: "上架状态",
            align: "center",
            sortable: true,
            minWidth: "120",
          },
           {
            prop: "operatorInfo",
            label: "操作人",
            slot: true,
            minWidth: "100",
          },
          {
            prop: "date",
            label: "日期",
            align: "left",
            minWidth: "210",
            formatter: function (val, row) {
              var html =
                "创建时间：" +
                row.createTimeText +
                 "<br/>" +
                "完成收货：" +
                (row.completeReceiptDateText||"" )+
               "<br/>" +
                "完成上架：" +
                (row.completePutOnDateText||"" );
              return html;
              }
          }, 
        
        ],
      },
      searchData: {
        //搜索列配置

        search: [
             {
            type: "input",
            key: "key",
            label: "单据号",
            placeholder: "上架单号/收货单号/WMS进仓号",
            clearable: true,
          },
            {
            type: "input",
            key: "SKUCode",
            label: "SKU编码",
            placeholder: "SKU编码",
            clearable: true,
          },
          {
            type: "select",
            key: "WarehouseId",
            prop: "WarehouseId",
            label: "仓库",
            multiple: true,
            slot: true,
            placeholder: "请选择仓库",
            option: this.warehouses,
          },
          
        ],
        ///高级搜索配置
        moreSearch: [
          {
            key: "tdate",
            prop: "tdate",
            slot: true,
            label: "",
            hideLabel: true,
          },
          {
            type: "select",
            key: "realName",
            prop: "realName",
            label: "操作人",
            multiple: true,
            slot: true,
            placeholder: "",
            option: this.userList,
          },
        ],
      },
     

      buttonList: [],
      //------上架
      locationList:[],
      addFormVisible: false,
      addLoading: false,
      addForm: {
        TFPutOnStockID: 0,
        locationCode: "",
        
        Remark: "",
      },
      addFormRules: {
        locationCode: [
          { required: true, message: "请选择上架库位", trigger: "change" },
        ],
        
      },

      //-------------
      allKinds:{
        bePutOnCount:0,
        onTheShelfCount:0,
      },
      warehouses: [],

      statusList: [
        {
          value: 10,
          text: "待上架",
        },
        {
          value: 20,
          text: "已上架",
        },
       
      ], //同步状态

      proListVisible: false,
    };
  },
  methods: {
    handleClick(tab, event) {
      let searchDeep = JSON.parse(JSON.stringify(this.searchData.search));
      searchDeep.forEach((item) => {
        if (item.key == "InventoryStatus" && this.activeName !== "all") {
           item.hide = true;
        } else {
          item.hide = false;
        }
      });
       this.filters.InventoryStatus =[]
      if(this.activeName !== "all"){
          var arr =[(this.activeName*1)];
         this.$set(this.filters, "InventoryStatus", arr);
      }
     
      this.$set(this.searchData, "search", searchDeep);
      this.newfilters = JSON.parse(JSON.stringify(this.filters));
      this.initTable();
    },
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },
    resetBtn() {
      this.filters = {
        DateType :"tos.CreateTime"
      }
      this.$set(this.filters,'status',[])

    },
    //查询列表
    initTable() {
      const { WarehouseId, key, tdate,DateType,SKUCode,realName } =
        this.newfilters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        key,
        SKUCode,
        DateType,
        realName: thereAre(realName),
        WarehouseIDs: thereAre(WarehouseId),
      };
      if (tdate != null && tdate != "null" && tdate != "") {
        para.StartDate = tdate[0];
        para.EndDate = tdate[1];
      }
      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      getPutOnStockTaskAsync(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
        if(this.tableData.length>0){
          this.allKinds.bePutOnCount=this.tableData[0].bePutOnCount
          this.allKinds.onTheShelfCount=this.tableData[0].onTheShelfCount
        }else{
          this.allKinds.bePutOnCount=0
          this.allKinds.onTheShelfCount=0
        }
      });
    },
    //导出
    handleExport() {
      let row = this.selectRows.rows;
      let TFPutOnStockIDs = row
        .map((item) => item.tfPutOnStockID)
        .join(",");
       const { WarehouseIDs, key, tdate,DateType,SKUCode } =
        this.newfilters;
      let para = {
        page: 1,
        pageSize: 60001,
        key,
        DateType,
        SKUCode,
        WarehouseIDs: thereAre(WarehouseIDs),
        TFPutOnStockIDs
      };
      if (tdate != null && tdate != "null" && tdate != "") {
        para.StartDate = tdate[0];
        para.EndDate = tdate[1];
      }
      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios({
        url: exportPutOnStockAsyncOut,
        method: "post",
        data: para,
        //responseType: "blob",
      })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;

            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    //查询日志
    getbusinessLoglist(row) {
      this.currentRow = row;
      this.showLog = true;
    },
   

    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },

    //弹出上架框
    onSubmitadd() {
      if (this.selectRows.rows == null || this.selectRows.rows.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }
      if (this.selectRows.rows != null && this.selectRows.rows.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });

        return;
      }
      if (this.selectRows.rows[0].inventoryStatus !== 10) {
        this.$message({
          message: "请选择状态为[待上架]上架单！",
          type: "error",
        });

        return;
      }

       
      this.addForm.TFPutOnStockID = this.selectRows.rows[0].tfPutOnStockID;
      if (this.addForm.TFPutOnStockID <= 0) {
        this.$message({
          message: "上架单数据错误，请刷新页面！",
          type: "error",
        });
      }
      var warehouseId=this.selectRows.rows[0].warehouseID;
       this.locationList=[];
        getWarehouseLocationByWarehouseId({warehouseId:warehouseId}).then((res) => {
      
        if(res.data.success){
            this.addFormVisible = true;
            this.addLoading = false;
            this.locationList=res.data.response;
        }
        else {
          this.$message({
          message: res.data.msg,
          type: "error",
         });
          
        }
      });

    
    },
    //隐藏签收框
    onSubmicancel() {
      this.addFormVisible = false;
      this.$refs["addRuleForm"].resetFields();
    },
    //上架
    onAddSubmit() {
      let para = Object.assign({}, this.addForm);
      console.log(para);
      let _this = this;
      this.$refs.addRuleForm.validate((valid) => {
        if (valid) {
          var user = JSON.parse(window.localStorage.user);
          if (!user && user.id == 0) {
            this.$message({
              message: "用户信息为空，先登录",
              type: "error",
            });
            _this.$router.replace(
              _this.$route.query.redirect ? _this.$route.query.redirect : "/"
            );
          }
          para.locationCode=thereAre(this.addForm.locationCode)
            this.addLoading = true;
            insertTFPutOnStock(para).then((res) => {
              this.addLoading = false;
              console.log(res);
              if (res.data.success) {
                this.addFormVisible = false;
                this.$refs["addRuleForm"].resetFields();
                this.initTable();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          }
        
      });
    },
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);

    let user = JSON.parse(window.localStorage.user);
    this.warehouses = user.warehouseList;

    getOperatorInfo().then((res) => {
      this.userList = res.data.response;
    });
  },
};
</script>

<style scoped>
.dateSelect {
  width: 130px;
  margin-right: 12px;
}
</style>